<template>
    <div id="content" ref='container'>
        <div v-show="isLoading" class="loading-wraper">
            <img
                class="loading"
                src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/loading.be43c23130aad283.svg"
            />
        </div>
        <div ref="app" class="app-show-box" id='app' :style="` min-height: ${showError ? 0 : '100vh'};`">
            <div class="app-bar-msg" :style="{'border-bottom': isPlayEnd ? '0.01rem solid rgba(255,255,255,0.08)' : ''}">
                <div class='app-bar-info' v-if='showShareInfo'>
                    <div class='app-bar-icon'>
                        <img :src="userInfo.iconUrlList[0]" class='icon-img'/>
                    </div>
                    <div class='app-bar-txt'>
                        <div class="nick-name">{{userInfo.nickName}}</div>
                        <div class="des" v-if='registerDays<10'>正在使用<span style="color:rgba(255,80,0,1)">快影</span>，邀请你一起创作精彩视频</div>
                        <div class="des" v-else>在快影等你<span style="color:#F7365D">{{registerDays}}</span>天</div>
                    </div>
                </div>
                <div class='app-bar-info' v-else>
                    <div class='app-bar-icon'>
                        <img :src="shareUserIcon" class='ky-icon'/>
                    </div>
                    <div class='app-bar-txt'>
                        <div class="no-user">快影 ｜ 爆款短视频一键制作</div>
                    </div>
                </div>
                <div class='app-bar-btn'>
                    <template v-if="isWexin">
                        <WxOpenTag :extInfo="openMvTabUrl" :errorHandler="wxOpenHandler">
                            <div class='btn-txt'>去看看</div>
                        </WxOpenTag>
                    </template>
                    <div v-else class='btn-txt' @click="openKy('exp2-try', openMvTabUrl)">去看看</div>
                </div>
            </div>
            <div class="app-video-box"  id='main-box' v-if='!showError'>
                <Video
                    :videoId="id"
                    :width="width"
                    :height="height"
                    :source="mainVideoUrl"
                    :cover="mainCoverUrl"
                    @isPlayEnd="getPlayState"
                    :radius="0.16"
                ></Video>
            </div>
            <div class="app-video-rec"  id='rec-box' v-if="!showError">
                <div class='pre-video' id='pre-video'>
                    <VideoLoop
                        :videoId="id"
                        :width="width"
                        :height="height"
                        :source="mainVideoUrl"
                        :cover="mainCoverUrl"
                        :radius="0.16"
                    ></VideoLoop>
                </div>
                <div class='side-list' id="side-list">
                    <!-- 推荐相似 -->
                    <div class='rec-title'>
                        <img src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/same-title.png' class='rec-img' />
                    </div>
                    <div class='rec-list'>
                        <template v-if="isWexin">
                            <WxOpenTag 
                                v-for="(item,index) in recData.slice(0,2)" 
                                :key="item.id" 
                                :extInfo="`${openMvTabUrl}?id=${item.id}`" 
                                :errorHandler="wxOpenHandler"
                                class='rec-box'
                                :style="{'border': index === 0 ? '0.02rem solid #F7365D':''}"
                                >
                                <img :src='item.templateBean.coverUrl' class='rec-box-img' :style="` object-fit: ${item.templateBean.width / item.templateBean.height > 1 ? 'contain' : 'cover'};`" />
                            </WxOpenTag>
                        </template>
                        <div 
                            v-else
                            v-for="(item,index) in recData.slice(0,2)" 
                            :key="item.id" 
                            class='rec-box'
                            @click='handleRecList(index,item)'
                            :style="{'border': index === recVideoIndex ? '0.02rem solid #F7365D':''}">
                            <img :src='item.templateBean.coverUrl' class='rec-box-img' :style="` object-fit: ${item.templateBean.width / item.templateBean.height > 1 ? 'contain' : 'cover'};`" />
                        </div>
                    </div>
                    <!-- 推荐热门 -->
                    <div class='rec-title' style='margin-top: 0.3rem'>
                        <img src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/hot-title.png' class='rec-img' />
                    </div>
                    <div class='rec-list'>
                        <template v-if="isWexin">
                            <WxOpenTag 
                                v-for="(item,index) in recData.slice(2,4)" 
                                :key="item.id" 
                                class='rec-box'
                                :extInfo="`${openMvTabUrl}?id=${item.id}`" 
                                :errorHandler="wxOpenHandler"
                                :style="{'border': index+2 === recVideoIndex ? '0.02rem solid #F7365D':''}">
                                <div class='top-level'>
                                    <img v-if='index === 0' class='level-img' src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/hot-1.png'/>
                                    <img v-else class='level-img' src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/hot-2.png'/>
                                </div>
                                <img :src='item.templateBean.coverUrl' class='rec-box-img' :style="` object-fit: ${item.templateBean.width / item.templateBean.height > 1 ? 'contain' : 'cover'};`" />
                            </WxOpenTag>
                        </template>
                        <div 
                            v-else
                            v-for="(item,index) in recData.slice(2,4)" 
                            :key="item.id" 
                            class='rec-box'
                            @click='handleRecList(index+2,item)'
                            :style="{'border': index+2 === recVideoIndex ? '0.02rem solid #F7365D':''}">
                            <div class='top-level'>
                                <img v-if='index === 0' class='level-img' src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/hot-1.png'/>
                                <img v-else class='level-img' src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/hot-2.png'/>
                            </div>
                            <img :src='item.templateBean.coverUrl' class='rec-box-img' :style="` object-fit: ${item.templateBean.width / item.templateBean.height > 1 ? 'contain' : 'cover'};`" />
                        </div>
                    </div>
                    <div class='rec-more-box'>
                        <template v-if="isWexin">
                            <WxOpenTag :extInfo="openMvTabUrl" :errorHandler="wxOpenHandler">
                                <div class='rec-more-btn'>
                                    <div class='more-btn-txt'>更多</div>
                                    <div class='arrow-icon'>
                                        <img src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/b-arrow.png' class='arrow-img' />
                                    </div>
                                </div>
                            </WxOpenTag>
                        </template>
                        <div v-else @click="openKy('exp2-more', openMvTabUrl)" class='rec-more-btn'>
                            <p class='more-btn-txt'>更多</p>
                            <div class='arrow-icon'>
                                <img src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/b-arrow.png' class='arrow-img' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="app-bottom-fixed" v-if="!showError">
                    <div class='app-bottom-box'>
                        <div class="app-bottom-user">
                            <p class='user-name'>{{ mainUserName }}</p>
                            <!-- <div class='user-name'>
                                <template v-if="isWexin">
                                    <WxOpenTag :extInfo="openUrl" :errorHandler="wxOpenHandler">
                                        <p>@{{ mainUserName }}</p>
                                    </WxOpenTag>
                                </template>
                                <p v-else @click="openKy('userName',openMvTabUrl)" class='user-name'>
                                    @{{ mainUserName }}
                                </p>
                            </div> -->
                            <div class="template-des">
                                {{ mainVideoDes }}
                            </div>
                        </div>
                        <div class='app-bottom-info'>
                            <div class='info-line'></div>
                            <div class='template-use'>
                                <div class='use-count'>
                                    {{ this.mainUseCount }}
                                </div>
                                <div class='use-txt'>使用量</div>
                            </div>
                        </div>
                    </div>
                    <div class="app-use-btn">
                        <template v-if="isWexin">
                            <WxOpenTag :extInfo="openUrl" :errorHandler="wxOpenHandler">
                                <div class='app-use-btn'>
                                    <p class='btn-txt'>免费使用同款</p>
                                </div>
                            </WxOpenTag>
                        </template>
                        <div v-else @click="openKy('edit', openUrl)" class='app-use-btn'>
                            <p class='btn-txt'>免费使用同款</p>
                        </div>
                    </div>
            </div>     
        </div>
        <div v-show="showError" class="app-exit-tip">
            <div class="exit-img"></div>
            <div class="exit-text">
                {{ modelErrorMsg }}
                <br />{{$t('clickToView')}}
            </div>
        </div>
    </div>
</template>

<script>
import Video from '../components/VideoV2.vue';
import VideoLoop from '../components/VideoV2Loop.vue'
import WxOpenTag from '../components/WxOpenTag.vue';
import { getUrlParam } from '@/utils/url';
import { getCookie } from '@/utils/cookie';
import { openOrDownloadKwaiying } from '@/utils/device';
import { get } from '../utils/utils';
import { wxShareConfig, isWexin, wxInit } from '@/utils/wx';
import { WebpMachine } from 'webp-hero';
// 支持webp 格式图片
const webpMachine = new WebpMachine();

export default {
    name: 'auto-side',
    components: {
        Video,
        VideoLoop,
        WxOpenTag,
    },
    data() {
        return {
            showError: false,
            id: '',
            show: false,
            width: 0,
            height: 0,
            mainUseCount: 0,
            modelErrorMsg: '',
            isWexin: isWexin,
            openUrl: '',
            isLoading: true,
            mainVideoUrl:'',
            mainCoverUrl:'',
            mainUserName:'',
            mainVideoDes:'',
            recMain:[],
            pageTag: 'kwaiying-template-share',
            userInfo:{},
            showShareInfo:false,
            source: {},
            recData:[],
            mainData:{},
            sameData:[],
            hotData:[],
            leftData: [],
            rightData: [],
            shareUserIcon:'https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/ky-icon-v.png',
            openMvTabUrl:'kwaiying://mv',
            isPlayEnd: false,
            registerDays:0,
            recVideoIndex:0,
            cardType:'',
            shareCardCount:'',
        };
    },
    props: {
    },
    watch: {
        isPlayEnd: { //深度监听，可监听到对象、数组的变化
            handler() {
                let card = document.getElementById('main-box');
                let rec = document.getElementById('rec-box');
                let pre = document.getElementById('pre-video');
                let app = document.getElementById('app');
                let side = document.getElementById('side-list')
                if(this.isPlayEnd){
                    //console.log('666---',document.body.clientHeight/document.body.clientWidth)
                    //console.log('ua',/UCBrowser/i.test(navigator.userAgent))
                    if(/UCBrowser/i.test(navigator.userAgent)){
                        app.style.padding = '0rem 0 3.68rem 0';
                    }
                    else{
                        app.style.padding = '1.2rem 0 3.68rem 0';
                    }
                    const { w, h } = this.computedVideoSize(this.mainData.templateBean.width,this.mainData.templateBean.height,'rec');
                    this.width = w;
                    this.height = h;
                    card.style.transform = 'scale(0.96)'
                    card.style.transitionDuration = "1s";
	                card.style.WebkitTransitionDuration = "1s";
                    setTimeout(function(){
                        rec.style.display = 'flex';
                        if(document.body.clientHeight/document.body.clientWidth<1.93){
                            rec.style.transform = 'scale(0.92)'
                        }
                        else if(document.body.clientHeight/document.body.clientWidth>1.94 && /UCBrowser/i.test(navigator.userAgent)){
                            rec.style.transform = 'scale(0.94)'
                        }
                        card.style.display = 'none';
                    },600);
                    setTimeout(function(){
                        side.style.transform = 'translateX(0)';
                        side.style.transitionDuration = "0.3s";
                        side.style.WebkitTransitionDuration = "0.3s";
                    },700)
                    setTimeout(function(){
                        pre.style.opacity = 1;
                    },600)
                    
                }
            },
            deep: true,
        },
    },
    computed: {
    },
    methods: {
        async getAbValue(params){
            const {data} = await get('/rest/n/kmovie/app/resource/getH5Abtest', params);
            console.log('card ab data',data)
            if (data && data.result === 1) {
                this.cardType = data.value;
                return data;
            }
            return Promise.reject(data);
        },
        handleRecList(index,item){
            this.recVideoIndex = index
            console.log('index---',this.recVideoIndex)
            this.openKy('exp2-side-card',`${this.openMvTabUrl}?id=${item.id}`)
        },
        getPlayState(item){
            this.isPlayEnd = item;
        },
        async getResource(templateId,userId){
            const res = await get('/rest/n/kmovie/app/resource/getTemplateReco', {
                templateId,
                userId
            });
            return res;
        },
        async pageInit(){
            this.isLoading = true;
            this.id = getUrlParam('id');
            this.openUrl = this.id ? `kwaiying://mv?id=${this.id}` : 'kwaiying://mv';
            const { data } = await this.getResource(getUrlParam('id'),getUrlParam('userId'));
            console.log('appdata==',data)
            if (data && data.result === 1) {
                //分享者信息
                if(data.userInfo !== null && data.userInfo !== undefined){
                    this.showShareInfo = true;
                    this.userInfo = data.userInfo;
                    this.registerDays = Math.floor(((new Date()).valueOf() - data.userInfo.registerTime) / (1000*3600*24));
                }
                const tempArr = data.sameTemplates?.slice(0,2)||[]
                this.recData = tempArr.concat(data.hotTemplates?.slice(0,2));
                this.mainData = data.mainTemplates;
                this.mainVideoUrl = this.mainData.videoUrl;
                this.mainCoverUrl = this.mainData.templateBean.coverUrl;
                this.mainUserName = this.mainData.user.nickName;
                this.mainVideoDes = this.mainData.templateBean.description;
                this.mainUseCount = this.formalCount(this.mainData.templateBean.useCount,0);
                this.shareCardCount = this.formalCount(this.mainData.templateBean.useCount,1);
                const { w, h } = this.computedVideoSize(this.mainData.templateBean.width,this.mainData.templateBean.height,'main');
                this.width = w;
                this.height = h;
                this.show = true;
                //ios兼容webpg格式图片
                for(let i=0;i<this.recData.length;i++){
                    if(this.recData[i].templateBean.coverUrl.indexOf('webp') !== -1){
                        this.recData[i].templateBean.coverUrl = this.recData[i].templateBean.coverUrl.indexOf('?')
                        ? this.recData[i].templateBean.coverUrl + '.webp'
                        : this.recData[i].templateBean.coverUrl + '?_webp_type=webp.webp';
                    // 增加.webp后缀 webpMachine来识别处理
                    webpMachine.polyfillDocument();
                    }
                }
                if (this.mainCoverUrl.indexOf('webp') !== -1) {
                    this.mainCoverUrl = this.mainCoverUrl.indexOf('?')
                        ? this.mainCoverUrl + '.webp'
                        : this.mainCoverUrl + '?_webp_type=webp.webp';
                    webpMachine.polyfillDocument();
                }
                if(this.cardType === 'card1'){
                    let noDes ='导入照片或视频，一键免费制作视频'
                    let desText = `${this.mainData.templateBean.description || noDes},${this.shareCardCount}人一键做同款`;
                    wxShareConfig(
                        {
                            title: this.mainData.name || '',
                            desc: desText || '',
                            imgUrl: this.mainData.templateBean.coverUrl || '',
                        },
                        this.pageTag,
                    );
                }
                else{
                    wxShareConfig(
                        {
                            title: this.mainData.name || '',
                            desc: this.mainVideoDes || '',
                            imgUrl: this.mainData.templateBean.coverUrl || '',
                        },
                        this.pageTag,
                    );
                }
            }else {
                this.modelErrorMsg = this.$t('noTemplate');
                this.showError = true;
            }
            this.isLoading = false;
        },
        //格式化使用量
        formalCount(num,type){
            if(num >= 10000){
                if(type == 0){
                    return  (num / 10000).toFixed(1) + 'w';
                }
                else{
                    return  (num / 10000).toFixed(1) + '万';
                }
            }else{
                return num;
            }
        },
        // 1280*720
        // 720*1280
        // 720*960
        // 目前有三种尺寸的视频，统一以视频宽度为基准等比缩放
        computedVideoSize(width, height, type) {
            console.log('window.screen.availHeight',window.screen.availHeight)
            if(type === 'main'){
                let result = {};
                // CW具体取值取决于视觉稿,单位为px
                const CW =  document.body.clientWidth;
                const per = width / CW;
                result = { w: CW, h: height / per };
                return result;
            }
            else{
                let CW = 0;
                let result = {};
                if(document.body.clientHeight/document.body.clientWidth < 1.93){
                    CW = window.screen.availWidth - 160;
                }else{
                    CW = window.screen.availWidth - 126;
                }
                const per = width / CW ;
                result = { w: CW, h: height / per  };
                return result;
            }
        },
        // 埋点
        openKy(type,url) {
            this.$weblog.collect('CLICK', 'model_share_use_button', { btn_name: type, id: this.id });
            openOrDownloadKwaiying(url, 800);
        },

        async getModelService(templateId) {
            const {data = {} } = await get('/rest/n/kmovie/app/resource/getTemplateById', {
                templateId,
            });
            return data;
        },
        wxOpenHandler(type, e) {
            this.$weblog.collect('CLICK', 'wx_button_launch_handler', {
                type,
                pageTag: this.pageTag,
                msg: JSON.stringify(e)
            });
            if (e?.detail?.errMsg === "launch:fail") {
                openOrDownloadKwaiying(this.openUrl, 800);
            }
        },
        //get mobile version
        getMobileInfo(){
            const uaArr = navigator.userAgent.split(' ') ;
            let osIndex = 0
            for(let i=0;i<uaArr.length;i++){
                if(uaArr[i] === 'OS' || uaArr[i] === 'Android'){
                    osIndex = i;
                    const mobileVersion = uaArr[osIndex+1].replace(RegExp("_", "g"), ".");
                    console.log('mobileVersion',mobileVersion);
                    return 
                }
            }
        }
    },
    mounted() {
        console.log('比值---',window.screen.availHeight/window.screen.availWidth)
        this.getAbValue({abParam:'Kuaiying_share_h5_card',webdid: getCookie('did') || getCookie('_did')});
        this.getPlayState()
        if (this.isWexin) {
            wxInit();
        }
        this.$weblog.collect('PV',  {
            share_url: location.href,
            page_name:'kwaiying-template-share-exp2'
        });

        this.pageInit();
        console.log("auto-side")
    },
};
</script>

<style lang="less" scoped>
#content {
    text-align: center;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #141414;
    & > div {
        overflow: hidden;
    }
}

.app-show-box {
    box-sizing: border-box;
    position: relative;
    min-height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
// 模板页头部信息
.app-bar-msg {
    z-index: 999;
    position: fixed;
    top: 0;
    width: 100%;
    height: 1.2rem;
    background: #141414;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .app-bar-info{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .app-bar-icon{
            overflow: hidden;
            margin: 0 0.24rem 0 0.32rem;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon-img{
                width: 0.76rem;
                height: 0.76rem;
                border-radius: 50%;
                overflow: hidden;
                border: 0.02rem solid #ffffff;
                box-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.15);
            }
            .ky-icon{
                width: 0.72rem;
            }
            //解决css中1px不兼容问题
            // .img-icon:after{
            //     content: '';
            //     position: absolute;
            //     top: 0;
            //     left: 0;
            //     border: 0.02rem solid #ffffff;
            //     box-sizing: border-box;
            //     width: 200%;
            //     height: 200%;
            //     border-radius: 50%;
            //     box-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.15);
            //     -webkit-transform: scale(0.5);
            //     transform: scale(0.5);
            //     -webkit-transform-origin: left top;
            //     transform-origin: left top;
            // }
        }
        .app-bar-txt{
            display: flex;
            flex-direction: column;
            .nick-name{
                font-size: 0.3rem;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                text-align: left;
                color: #ffffff;
                margin-bottom: 0.11rem;
            }
            .des{
                font-size: 0.22rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #727272;
            }
            .no-user{
                font-size: 0.26rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #727272;
            }
        }
    }
    .app-bar-btn{
        width: 1.2rem;
        height: 0.64rem;
        background: #262626;
        border-radius: 0.52rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.32rem;
        .btn-txt{
            font-size: 0.24rem;
            font-family: PingFangTC, PingFangTC-Semibold;
            font-weight: 600;
            color: rgba(255,255,255,0.9);
        }
    }
    .app-bar-img {
        width: 100%;
        height: auto;
    }
}
//分享视频
.app-video-box {
    height: 100%;
    display: flex;
    justify-content: center;
    width: 100%;
}
.app-video-rec{
    height: 100%;
    display: none;
    justify-content: center;
    padding: 0 0.46rem 0 0.48rem;
    box-sizing: border-box;
    width: 100%;
    .pre-video{
        opacity: 0;
        margin-right: 0.32rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .side-list{
        transform: translateX(100px);
        display: flex;
        //display: none;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .rec-title{
            width: 1.18rem;
            height: 0.26rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0.2rem;
            .rec-img{
                width: 1.18rem;
                height: 0.26rem;
            }
        }
        .rec-list{
            display: flex;
            flex-direction: column;
            align-items: center;
            .rec-box{  
                border: 0.02rem solid #141414;
                width: 1.28rem;
                height: 1.68rem;
                border-radius: 0.18rem;
                margin-bottom: 0.08rem;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                .top-level{
                    position: absolute;
                    z-index: 999;
                    top:0.04rem;
                    left:0.04rem;
                    width: 0.64rem;
                    height: 0.28rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .level-img{
                        width: 0.64rem;
                        height: 0.28rem;
                    }
                }
                .rec-box-img{
                    width: 1.2rem;
                    height: 1.6rem;
                    border-radius: 0.16rem;
                }
            }
        }
        .rec-more-box {
            margin-top: 0.12rem;
            .rec-more-btn {
                width: 1.2rem;
                height: 0.56rem;
                background: linear-gradient(45deg,#F52C6F, #F7365D, #FF5151);
                border-radius: 0.28rem;
                margin: 0 auto;
                overflow: hidden;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                .more-btn-txt{
                    margin-top:0.027rem;
                    font-size: 0.22rem;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    color: #ffffff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-left: 0.085rem;
                }
                .arrow-icon{
                    width: 0.24rem;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    .arrow-img{
                        width: 0.24rem;
                    }
                }
            }
        }
    }
}
//模板页使用信息以及底部button
.app-bottom-fixed {
    width: 100%;
    height: 3.68rem;
    position: fixed;
    overflow: hidden;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5) 32%, rgba(0, 0, 0, 0.6));
    .app-bottom-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.26rem 0.48rem 0.48rem 0.48rem;
        .app-bottom-user{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .user-name{
                font-size: 0.34rem;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                text-align: justify;
                color: rgba(255,255,255,0.9);
                margin-bottom: 0.16rem;
            }
            .template-des{
                font-size: 0.26rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: rgba(255,255,255,0.9);
                max-width: 4.28rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .app-bottom-info{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .info-line{
                width: 0.02rem;
                height: 0.8rem;
                background: rgba(255,255,255,0.2);
                margin-right: 0.41rem;
            }
            .template-use{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .use-count{
                    font-size: 0.38rem;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: right;
                    color: rgba(255,255,255,0.9);
                    margin-bottom: 0.16rem;
                }
                .use-txt{
                    font-size: 0.26rem;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: rgba(255,255,255,0.9);;
                }
            }
        }
    }
}

@keyframes btnBreath {
    0%{
        -webkit-transform: scale(0.88);
        -moz-transform:scale(0.88);
        transform: scale(0.88);
    }
    100%{
        -webkit-transform: scale(1);
        -moz-transform:scale(1);
        transform: scale(1);
    }
}

.app-use-btn {
    margin: 0 auto;
    width: 5.28rem;
    height: 1.04rem;
    border-radius: 0.52rem;
    background: linear-gradient(45deg,#F52C6F, #F7365D, #FF5151);
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: btnBreath 0.5s ease-out alternate infinite;
    .btn-txt{
        font-size: 0.3rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: rgba(255,255,255,0.9);
    }
}

.app-exit-tip {
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-size: 100%;
    .exit-img {
        width: 4.8rem;
        height: 3rem;
        background-image: url('https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/ky_empty_source.8e152a61dfc81d49.png');
        background-size: 100% 100%;
        margin-bottom: 0.18rem;
    }
    .exit-text {
        width: 4.9rem;
        font-size: 0.26rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #666666;
        line-height: 0.4rem;
    }
}
</style>
